export default __webpack_public_path__ + "static/media/cancel.b63ba6ab.svg";